export default __webpack_public_path__ + "img/394aeb2a829600711907e279f4779f4c.svg";